document.addEventListener('DOMContentLoaded', function() {
    var backButton = document.getElementById('backButton');
  
    backButton.addEventListener('click', function() {
      if (document.referrer.trim() !== '') {
        window.location.href = document.referrer; // 前のページにリダイレクト
      } else {
        
        window.location.href = '/'; 
      }
    });
  });